import { render, staticRenderFns } from "./RegisteredProductsRepairs.vue?vue&type=template&id=843e0cec"
import script from "./RegisteredProductsRepairs.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsRepairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports